// src/components/Features.js
import React from 'react';
import { FaEdit, FaMobileAlt, FaDatabase, FaChartBar, FaPlug, FaUsers } from 'react-icons/fa';

const features = [
  {
    icon: <FaEdit />,
    title: 'No-Code Workflow Editing',
    desc: 'Drag-and-drop interface with visual builder and real-time updates',
    image: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?q=80&w=2070&auto=format&fit=crop'
  },
  {
    icon: <FaMobileAlt />,
    title: 'Multi-Channel Deployment',
    desc: 'Seamless integration across WhatsApp, Web, and Mobile Apps',
    image: 'https://www.seobility.net/en/wiki/images/1/17/Multichannel-marketing.png'
  },
  {
    icon: <FaDatabase />,
    title: 'Dynamic Content Management',
    desc: 'AI-driven personalization and instant content updates',
    image: 'https://img.freepik.com/free-vector/high-roi-content-abstract-concept-vector-illustration-social-media-marketing-online-content-production-high-roi-publication-return-investment-measuring-digital-strategy-abstract-metaphor_335657-2293.jpg'
  },
  {
    icon: <FaChartBar />,
    title: 'AI-Powered Optimization',
    desc: 'Analytics and A/B testing for conversation efficiency',
    image: 'https://www.shutterstock.com/image-vector/person-resting-ai-working-guy-600nw-2387837061.jpg'
  },
  {
    icon: <FaPlug />,
    title: 'Custom Integrations',
    desc: 'Connect with CRM, ERP, and third-party APIs',
    image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?q=80&w=2070&auto=format&fit=crop'
  },
  {
    icon: <FaUsers />,
    title: 'Role-Based Access',
    desc: 'Secure admin controls with audit logs',
    image: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?q=80&w=2070&auto=format&fit=crop'
  }
];

const Features = () => {
  return (
    <section id="features" className="py-16">
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-12">Key Features</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition transform hover:-translate-y-1">
              <img 
                src={feature.image} 
                alt={feature.title} 
                className="w-full h-40 object-cover rounded-t-lg mb-4" 
                onError={(e) => { e.target.src = 'https://via.placeholder.com/400x160?text=Image+Not+Found'; }}
              />
              <div className="text-blue-600 text-3xl mb-4">{feature.icon}</div>
              <h3 className="text-xl font-semibold mb-2">{feature.title}</h3>
              <p className="text-gray-600">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;